module.exports = __webpack_public_path__ + "static/media/video.4f3d554d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/backgrounds/video.svg
// module id = 531
// module chunks = 0